import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subscriber } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private eventSource: EventSource | null = null;

  constructor(private zone: NgZone, private http: HttpClient) { }

  postFormData(url: string, formData: FormData): Observable<any> {
    const headers = new HttpHeaders({ 'Accept': 'application/json' });
    return this.http.post(url, formData, { headers, responseType: 'text' });
  }

  listenToProgressEvents(url: string): Observable<number> {
    return new Observable((subscriber: Subscriber<number>) => {
      this.eventSource = new EventSource(url);

      this.eventSource.addEventListener('progress', (event: MessageEvent) => {
        this.zone.run(() => {
          try {
            const progress = parseFloat(event.data);
            subscriber.next(progress);
          } catch (err) {
            console.error('Failed to parse progress:', err);
          }
        });
      });

      this.eventSource.onerror = (error) => {
        this.zone.run(() => subscriber.error(error));
      };

      return () => {
        this.eventSource?.close();
      };
    });
  }

  close(): void {
    this.eventSource?.close();
    this.eventSource = null;
  }
}
